import { graphql } from 'react-relay';

import { TaskWindowPaginator_query$key } from '../../../relay/__generated__/TaskWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const TaskWindowPaginator_query = graphql`
  fragment TaskWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: TaskFilter }
    order: { type: TaskOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "TaskWindowPaginatorRefreshQuery") {
    tasks(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
          status
        }
      }
      ...TaskConnectionDataTable_taskConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<TaskWindowPaginator_query$key>, 'fragment'>;

const TaskWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={TaskWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.tasks.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default TaskWindowPaginator;
